import GrassDemo from '@components/GrassDemo';

export default function App() {
  return <GrassDemo />;
}